import { ChartDataset } from 'chart.js';

import Chart from '../../../../common/charts';
import { optionAll } from '../../constants';
import { useOverallChartData } from '../../hooks/useOverallChartData';

type TeamOption = {
  id: string;
  label: string;
  value: string;
};

export function LineChart({
  selectedTeam,
  setSelectedTeam,
}: {
  selectedTeam: TeamOption | null;
  setSelectedTeam: (team: TeamOption | null) => void;
}): JSX.Element {
  const chartData = useOverallChartData();
  const handleDatasetClick = (_: any, elements: any[]): void => {
    if (elements.length > 0) {
      const { datasetIndex } = elements[0] as { datasetIndex: number };
      const clickedTeam = chartData.datasets[datasetIndex] as ChartDataset<
        'line',
        number[]
      > & { id: string };
      if (!clickedTeam.label) return;
      setSelectedTeam(
        selectedTeam?.label === clickedTeam.label
          ? optionAll
          : {
              id: clickedTeam.id,
              label: clickedTeam.label,
              value: clickedTeam.id,
            },
      );
    }
  };

  const modifiedData = {
    ...chartData,
    datasets:
      !selectedTeam || selectedTeam?.value === optionAll.value
        ? chartData.datasets.map((dataset) => ({
            ...dataset,
            hidden: false,
          }))
        : chartData.datasets.map((dataset) => ({
            ...dataset,
            hidden: selectedTeam?.label !== dataset.label,
          })),
  };

  return (
    <div className="w-full h-full bg-white p-2 pt-6 rounded-xl">
      <Chart
        type="line"
        data={modifiedData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'center',
              onClick: (e, legendItem) => {
                setSelectedTeam(
                  selectedTeam?.label === legendItem.text
                    ? optionAll
                    : {
                        id: '',
                        label: legendItem.text,
                        value: legendItem.text,
                      },
                );
              },
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
                font: {
                  size: 12,
                },
              },
            },
          },
          scales: {
            x: {
              grid: {
                display: true,
              },
            },
            y: {
              grid: {
                display: true,
              },
            },
          },
          interaction: {
            mode: 'point',
            intersect: true,
          },
          onClick: handleDatasetClick,
        }}
      />
    </div>
  );
}
